import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/identificador' };
/////////////////////////////////////////////////////////////////////////////////

export function createIdentificadorCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateIdentificadorCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listIdentificadorCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findIdentificadorCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllIdentificadorCadastro() {
  return httpService.get({ ...args, path: '/identificador/all' });
}

export function deleteIdentificadorCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

